import { render, staticRenderFns } from "./Awards.vue?vue&type=template&id=da894036&scoped=true&"
var script = {}
import style0 from "./Awards.vue?vue&type=style&index=0&id=da894036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da894036",
  null
  
)

export default component.exports